import { render, staticRenderFns } from "./ServiceSubCategoriesList.vue?vue&type=template&id=ffd9d158"
import script from "./ServiceSubCategoriesList.vue?vue&type=script&lang=js"
export * from "./ServiceSubCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports